// extracted by mini-css-extract-plugin
export default {"ArticleEdit":"jp_a bhg_qr bhg_a bhg_w bhg_ea","ArticleEdit__draft":"jp_b bhg_vt bhg_va bhg_so bhg_sm bhg_sn bhg_ru bhg_fg"};